export const EVENT_AUTOPILOT_FUNCTION_URL =
  process.env.REACT_APP_EVENT_AUTOPILOT_FUNCTION_URL ||
  "https://us-central1-invitations778.cloudfunctions.net/manageEventAutopilot";

export const callEventAutopilot = async ({ idToken, eventId, action, payload = {} }) => {
  const response = await fetch(EVENT_AUTOPILOT_FUNCTION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ eventId, action, ...payload }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.message || "AUTOPILOT_REQUEST_FAILED");
    error.code = result.code || `HTTP_${response.status}`;
    error.details = result.details;
    throw error;
  }
  return result;
};
